import { render, staticRenderFns } from "./HomeInformationCard.vue?vue&type=template&id=5073247f&scoped=true&"
import script from "./HomeInformationCard.vue?vue&type=script&lang=ts&"
export * from "./HomeInformationCard.vue?vue&type=script&lang=ts&"
import style0 from "./HomeInformationCard.vue?vue&type=style&index=0&id=5073247f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073247f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
